<app-modal-video-calls [chat]="chat" [Service]="Service" *ngIf="isCall;else incomingRef"></app-modal-video-calls>

<ng-template #incomingRef>
  <div #wrap class="calc--wrap">
    <video #testVideo autoplay playsinline [muted]="true"></video>
    <div class="bottom-panel text-center">

      <button
        placement="top"
        tooltip=""
        [tooltip]="isMute ? 'Включить&nbsp;звук' : 'Без&nbsp;звука'"
        class="btn {{isMute ? 'btn-danger' : ' btn-dark'}} btn-ico rounded-circle mx-2"
        (click)="toggleMute()"
        id="mute-call"
      >
        <i-feather [name]="isMute ? 'mic-off' : 'mic'"></i-feather>
      </button>


      <button
        placement="top"
        [tooltip]="isVideoDisable ? 'Включить&nbsp;видео' : 'Отключить&nbsp;видео'"
        class="btn {{isVideoDisable ? 'btn-danger' : ' btn-dark'}} btn-ico rounded-circle mx-2"
        (click)="toggleVideo()"
        id="mute-call-video"
      >
        <i-feather [name]="isVideoDisable ? 'video-off' : 'video'"></i-feather>
      </button>
      <button
        placement="top"
        tooltip="Принять&nbsp;звонок"
        (click)="call()"
        class="btn btn-success btn-ico rounded-circle mx-2"
        id="end-call">
        <i-feather name="phone-call"></i-feather>
      </button>
    </div>
  </div>
</ng-template>
